import fly from '@/flyio';
declare let process: any;
export default {
    // 首页获取出版图书
    getPublishBook(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/book/list", param);
    },
    // 首页获取图书榜
    getBookRanks(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/book/top10", param);
    },
    // 新闻详情
    getNewsDetail(id: number) {
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/news/detail/" + id);
    },
    // 作者详情
    getAuthorDetail(id: string) {
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/author/detail/" + id);
    },
    // 作者详情下对应数字资源列表
    getAuthorResources(id: string, pg: number, ps: number) {
        const param = { page: pg, pageSize: ps };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/author/resources/" + id, param);
    },
    // 出版社详情
    getPublishDetail(id: string) {
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/publisher/detail/" + id);
    },
    // 成功案例详情
    getCaseDetail(id: string) {
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/case/detail/" + id);
    },
    // 出版社下对应数字资源列表
    getPublishResources(id: string, pg: number, ps: number) {
        const param = { page: pg, pageSize: ps };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/publisher/resources/" + id, param);
    }
};
